{
  "auth": {
    "agree": "Я согласен с ",
    "createAccount": "Создать аккаунт",
    "createNewAccount": "Создать новый аккаунт",
    "email": "Email",
    "phone": "Телефон",
    "login": "Логин",
    "password": "Пароль",
    "recover_password": "Восстановить пароль",
    "sign_up": "Регистрация",
    "keep_logged_in": "Оставаться в системе",
    "termsOfUse": "Условия пользования.",
    "reset_password": "Сбросить пароль",
    "forgot_password": "Забыли пароль?",
    "keep_signed": "Оставаться в системе на этом устройстве"
  },
  "404": {
    "title": "Эта страница ушла на рыбалку.",
    "text": "Если вы считаете, что это ошибка, пожалуйста, отправьте нам сообщение на ",
    "back_button": "Назад к панели управления"
  },
  "typography": {
    "primary": "Основные текстовые стили",
    "secondary": "Второстепенные текстовые стили"
  },
  "dashboard": {
    "versions": "Версии",
    "setupRemoteConnections": "Настроить удаленные подключения",
    "currentVisitors": "Текущие посетители",
    "navigationLayout": "макет навигации",
    "topBarButton": "Верхняя панель",
    "sideBarButton": "Боковая панель"
  },
  "language": {
    "english": "Английский",
    "russian": "Русский"
  },
  "menu": {
    "auth": "Авторизация",
    "buttons": "Кнопки",
    "timelines": "Временные шкалы",
    "dashboard": "Панель управления",
    "billing": "Биллинг",
    "login": "Вход",
    "preferences": "Настройки аккаунта",
    "payments": "Платежи",
    "settings": "Настройки приложения",
    "pricing-plans": "Тарифные планы",
    "payment-methods": "Способы оплаты",
    "signup": "Регистрация",
    "recover-password": "Восстановление пароля",
    "recover-password-email": "Восстановление пароля по электронной почте",
    "404": "404",
    "faq": "FAQ",
    "users": "Пользователи",
    "projects": "Проекты",
    "expert": "Эксперты",
    "subscription": "Подписки",
    "tariff": "Тарифы"
  },
  "messages": {
    "all": "Просмотреть все сообщения",
    "new": "Новые сообщения от {name}",
    "mark_as_read": "Отметить как прочитанное"
  },
  "navbar": {
    "messageUs": "Запросы на веб-разработку:",
    "repository": "GitHub Репозиторий"
  },
  "notifications": {
    "all": "Просмотреть все уведомления",
    "less": "Просмотреть меньше уведомлений",
    "mark_as_read": "Отметить как прочитанное",
    "sentMessage": "отправил вам сообщение",
    "uploadedZip": "загрузил новый файл Zip с {type}",
    "startedTopic": "начал новую тему"
  },
  "user": {
    "language": "Изменить язык",
    "logout": "Выход",
    "profile": "Профиль",
    "settings": "Настройки",
    "billing": "Биллинг",
    "faq": "FAQ",
    "helpAndSupport": "Помощь и поддержка",
    "projects": "Проекты",
    "account": "Аккаунт",
    "explore": "Исследовать"
  },
  "treeView": {
    "basic": "Основной",
    "icons": "Иконки",
    "selectable": "Выбираемый",
    "editable": "Редактируемый",
    "advanced": "Расширенный"
  },
  "chat": {
    "title": "Чат",
    "sendButton": "Отправить"
  },
  "spacingPlayground": {
    "value": "Значение",
    "margin": "Отступ",
    "padding": "Внутренний отступ"
  },
  "spacing": {
    "title": "Отступы"
  },
  "cards": {
    "cards": "Карточки",
    "fixed": "Фиксированные",
    "floating": "Плавающие",
    "contentText": "Уникальные полосы зебр делают их одними из самых узнаваемых животных.",
    "contentTextLong": "Уникальные полосы зебр делают их одними из самых узнаваемых животных. Они обитают в различных местах: на лугах, саваннах, в лесах, колючих кустарниках, горах и прибрежных холмах. Различные антропогенные факторы оказали сильное влияние на популяции зебр, особенно охота на шкуры и разрушение мест обитания. Зебра Греви и горная зебра находятся под угрозой исчезновения. Хотя равнинные зебры гораздо более многочисленны, один подвид, квагга, вымер.",
    "rowHeight": "Высота строки",
    "title": {
      "default": "По умолчанию",
      "withControls": "С контролами",
      "customHeader": "С пользовательским заголовком",
      "withoutHeader": "Без заголовка",
      "withImage": "С изображением",
      "withTitleOnImage": "С заголовком на изображении",
      "withCustomTitleOnImage": "С пользовательским заголовком на изображении",
      "withStripe": "С полосой",
      "withBackground": "С фоном"
    },
    "button": {
      "main": "Основная",
      "cancel": "Отменить",
      "showMore": "Показать больше",
      "readMore": "Показать больше"
    },
    "link": {
      "edit": "Редактировать",
      "setAsDefault": "Установить по умолчанию",
      "delete": "Удалить",
      "traveling": "Путешествие",
      "france": "Франция",
      "review": "Отзыв",
      "feedback": "Оставить отзыв",
      "readFull": "Прочитать полную статью",
      "secondaryAction": "Дополнительное действие",
      "action1": "Действие 1",
      "action2": "Действие 2"
    }
  },
  "colors": {
    "themeColors": "Цвета темы",
    "extraColors": "Дополнительные цвета",
    "gradients": {
      "basic": {
        "title": "Градиенты кнопок"
      },
      "hovered": {
        "title": "Градиенты кнопок при наведении",
        "text": "Осветление на 15% применяется к исходному стилю (градиенту или плоскому цвету) для состояния при наведении."
      },
      "pressed": {
        "title": "Градиенты кнопок при нажатии",
        "text": "Затемнение на 15% применяется к исходному стилю (градиенту или плоскому цвету) для состояния при нажатии."
      }
    }
  },
  "tabs": {
    "alignment": "Выравнивание вкладок",
    "overflow": "Переполнение вкладок",
    "hidden": "Вкладки со скрытым слайдером",
    "grow": "Растущие вкладки"
  },
  "helpAndSupport": "Помощь и поддержка",
  "aboutVuesticAdmin": "О Vuestic Admin",
  "supportAndConsulting": "Поддержка и консультации",
  "search": {
    "placeholder": "Поиск..."
  },
  "buttonSelect": {
    "dark": "Темный",
    "light": "Светлый"
  },
  "vuestic": {
    "search": "Поиск",
    "noOptions": "Элементы не найдены",
    "ok": "ОК",
    "cancel": "Отмена",
    "uploadFile": "Загрузить файл",
    "undo": "Отменить",
    "dropzone": "Перетащите файлы сюда для загрузки",
    "fileDeleted": "Файл удален",
    "closeAlert": "закрыть предупреждение",
    "backToTop": "наверх",
    "toggleDropdown": "переключить выпадающее меню",
    "carousel": "карусель",
    "goPreviousSlide": "перейти к предыдущему слайду",
    "goNextSlide": "перейти к следующему слайду",
    "goSlide": "перейти к слайду {index}",
    "slideOf": "слайд {index} из {length}",
    "close": "закрыть",
    "openColorPicker": "открыть палитру цветов",
    "colorSelection": "выбор цвета",
    "colorName": "цвет {color}",
    "decreaseCounter": "уменьшить счетчик",
    "increaseCounter": "увеличить счетчик",
    "selectAllRows": "выбрать все строки",
    "sortColumnBy": "сортировать столбец по {name}",
    "selectRowByIndex": "выбрать строку {index}",
    "resetDate": "сбросить дату",
    "nextPeriod": "следующий период",
    "switchView": "переключить вид",
    "previousPeriod": "предыдущий период",
    "removeFile": "удалить файл",
    "reset": "сбросить",
    "pagination": "Пагинация",
    "goToTheFirstPage": "Перейти на первую страницу",
    "goToPreviousPage": "Перейти на предыдущую страницу",
    "goToSpecificPage": "Перейти на {page} страницу",
    "goToSpecificPageInput": "Введите номер страницы для перехода",
    "goNextPage": "Перейти на следующую страницу",
    "goLastPage": "Перейти на последнюю страницу",
    "currentRating": "Текущий рейтинг {value} из {max}",
    "voteRating": "vote rating {value} of {max}",
    "optionsFilter": "options filter",
    "splitPanels": "split panels",
    "movePaginationLeft": "move pagination left",
    "movePaginationRight": "move pagination right",
    "resetTime": "reset time",
    "closeToast": "close toast",
    "selectedOption": "Selected option",
    "noSelectedOption": "Option is not selected",
    "breadcrumbs": "breadcrumbs",
    "counterValue": "counter value",
    "selectedDate": "selected date",
    "selectedTime": "selected time",
    "progressState": "progress state",
    "color": "цвет",
    "next": "Следующий",
    "back": "Предыдущий",
    "finish": "Финиш",
    "step": "шаг",
    "progress": "прогресс",
    "loading": "Загрузка",
    "sliderValue": "Current slider value is {value}",
    "switch": "Switch",
    "inputField": "Input field",
    "fileTypeIncorrect": "File type is incorrect",
    "select": "Select an option"
  }
}
